import { render, staticRenderFns } from "./DetailedHead.vue?vue&type=template&id=d6d49f20&"
import script from "./DetailedHead.vue?vue&type=script&lang=js&"
export * from "./DetailedHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports